import { useLayoutEffect, useState } from 'react';

/*
  Check to see if the element has an overflow
  Most of the implementation comes from: https://www.robinwieruch.de/react-custom-hook-check-if-overflow/
*/
export const useIsOverflow = (ref, callback) => {
  const [isOverflow, setIsOverflow] = useState(undefined);

  useLayoutEffect(() => {
    const { current } = ref;

    const trigger = () => {
      const hasOverflow = current.offsetWidth < current.scrollWidth;

      setIsOverflow(hasOverflow);

      if (callback) callback(hasOverflow);
    };

    if (current) {
      trigger();
    }
  }, [callback, ref]);

  return isOverflow;
};
